import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, PricePlanType } from '@systemeio/types';
import { useControlledSwr } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export function useUserPricePlans(currency) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== currency) {
    t1 = () => {
      if (currency) {
        return [`/api/dashboard/customer/price-plans/${currency}`, RequestModuleEnum.PricePlans];
      }
      return null;
    };
    $[1] = currency;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: userPricePlans,
    mutate: mutateUserPricePlans
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[3] !== mutateUserPricePlans || $[4] !== userPricePlans) {
    t2 = {
      userPricePlans,
      mutateUserPricePlans
    };
    $[3] = mutateUserPricePlans;
    $[4] = userPricePlans;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}